import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'react-i18next';
import Landing from '../src/legacy/components/pages/Landing/Landing';

export const Home = (): JSX.Element => {
  const { t } = useTranslation(['marketing']);

  return (
    <>
      <Head>
        <title>Bounce</title>
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://bouncelife.com" />
        <meta property="og:title" content="Bounce" />
        <meta property="fb:app_id" content="1855802768063770" />
        <meta
          property="og:image"
          content="/img/illustrations/landing/about-image.jpg"
        />
        <meta
          property="og:description"
          content={t('landing.banner.tagline')}
        />
      </Head>

      <Landing />
    </>
  );
};

export async function getStaticProps() {
  return {
    props: {} // will be passed to the page component as props
  };
}

export default Home;
